export const constants = {
	alerts: {
		iconClasses: {
			success: 'fa-check-circle',
			error: 'fa-exclamation-circle',
			info: 'fa-info-circle',
			warning: 'info'
		},
		alertClasses: {
			success: 'success',
			error: 'error',
			info: 'info',
			warning: 'warning'
		}
	}
};
